import { render } from "./FnNoticePanel.vue?vue&type=template&id=436a7cc8"
import script from "./FnNoticePanel.vue?vue&type=script&lang=js"
export * from "./FnNoticePanel.vue?vue&type=script&lang=js"

import exportComponent from "e:\\AiGreate\\tmp\\vertex\\webui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__